import { useEffect } from "react";

import { useOktaAuth } from "@okta/okta-react";
import { createFileRoute } from "@tanstack/react-router";

const LoginComponent = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const { redirect } = Route.useLoaderDeps();
  const navigate = Route.useNavigate();

  useEffect(() => {
    if (!authState) {
      return;
    }

    if (authState.isAuthenticated) {
      navigate({ to: redirect, replace: true });
    } else {
      oktaAuth.signInWithRedirect({
        originalUri: redirect,
      });
    }
  }, [oktaAuth, authState, navigate, redirect]);
};

export const Route = createFileRoute("/login")({
  loaderDeps: ({ search }) => ({ redirect: search.redirect }),
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => ({
    redirect: (search.redirect as string) || "",
  }),
  component: LoginComponent,
});
